import { ProLayout } from '@ant-design/pro-components';
import { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { buildMenuData } from '@/common/utils/route';

const APP_TITLE = '餐饮连锁经营智能体';

const PublicLayout = ({ routes }) => {
  const location = useLocation();
  const menuData = useMemo(() => {
    return buildMenuData(routes);
  }, [routes]);

  return (
    <ProLayout pure title={APP_TITLE} location={location} route={{ routes: menuData }}>
      <Outlet />
    </ProLayout>
  );
};

export default PublicLayout;
